const PAYMENT_WARNING_FEATURE = 'payment_warning_payment_types'
const DEFAULT_PAYMENT_WARNING_TYPES = ['sberbank', 'bnpl_sberbank']

/**
 * @returns {string[]}
 */
export const getPaymentWarningTypes = () => {
  const featureValue = window.$growthbookClient?.getFeatureValue(PAYMENT_WARNING_FEATURE)
  const paymentTypes = featureValue?.[0]?.value?.paymentTypes

  return Array.isArray(paymentTypes) ? paymentTypes : DEFAULT_PAYMENT_WARNING_TYPES
}

export const isYandexBrowser = () => /YaBrowser/i.test(navigator.userAgent)

/**
 * @param {string|null|undefined} paymentType
 * @returns {boolean}
 */
export const shouldShowPaymentWarning = (paymentType) => (
  Boolean(paymentType) && getPaymentWarningTypes().includes(paymentType) && !isYandexBrowser()
)
